// This import nonsense is because ng-packagr uses rollup and rollup sucks
import * as isPlainObjectImport from "lodash.isplainobject";
const isPlainObject = (<any>isPlainObjectImport).default || isPlainObjectImport;

/*
 * Recursive Object.freeze on plain objects and arrays
 */
export function deepFreeze(obj) {
    Object.freeze(obj);
    for (const key of Object.keys(obj)) {
        const val = obj[key];
        if (isPlainObject(val) || Array.isArray(val)) {
            deepFreeze(val);
        }
    }
}
